<template lang="html">
  <div class="">
    <button class="btn btn-success" type="button" name="button" @click="show">
        <i class="fas fa-cog"></i>
      {{blockTitle}} la ligne {{lineid}}
    </button>
    <modal :name="'preparation-modal-'+lineid">
        <div class="modal-header">
            <h4 class="text-left">Préparation de la ligne {{lineid}} :</h4>
       </div>
       <div class="modal-body">
         <div class="row">
           <div class="col-12">
             <p class="text-left">{{productQtyLine}} unité(s) de {{productRefLine}}</p>
             <h5 class="text-left">Fichier d'impression</h5>
             <img class="img-fluid" width="250px" :src="thumb" v-if='thumb != null && fileUploaded.srcurl == null' alt="">
             <file-upload btn-label="Envoyer le fichier" accept=".pdf,.png,.jpg,.jpeg" :url='url' :thumb-url='thumbUrl' :headers="headers" @change="onFileChange"></file-upload>
           </div>
         </div>
       </div>
       <div class="modal-footer">
         <button type="button" class="btn btn-danger" @click="hide" name="button">Annuler</button>
         <button type="button" class="btn btn-success" @click="valid" name="button">
           <i class="fas fa-check"></i>
           Valider la préparation
         </button>
       </div>
  </modal>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "Preparation",
  props : [
    "lineid",
    "productQtyLine",
    "productRefLine",
    "blockTitle",
    "thumb",
  ],
  data() {
    return {
      printers: [],
      selectedPrinter : "",
      /* Service node a lancer sur serveur pour être fonctionnel*/
      url: 'http://bonbonprint.candyprint.eu/ws/upload/'+this.lineid,
      headers: {},
      fileUploaded:[]
    };
  },
  methods: {
    valid : function(){
      var of_config = {
        oflineid:this.lineid,
        printableFile : this.fileUploaded.srcurl,
        thumbnailUrl : this.fileUploaded.thumburl,
        done : 1,
      };
      axios
        .post(
          "https://crm.bonbonprint.fr/api/index.php/of/configureofline",
          of_config,
          {
            headers: {
              'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9' //the token is a variable which holds the token
            }
          }
        )
        .then(response => {
          this.$emit('prepadone',response);
          this.$modal.hide('preparation-modal-'+this.lineid);
        });
    },
    show () {
         this.$modal.show('preparation-modal-'+this.lineid);
    },
    hide () {
             this.$modal.hide('preparation-modal-'+this.lineid);
    },
    onFileChange (file) {
     this.fileUploaded = file
     console.log(file);
   },
   thumbUrl (file) {
     return file.thumburl
   }
  },
}
</script>
